import _classCallCheck from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';

function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
}

export var FormErrorScroller = /*#__PURE__*/function (_React$Component) {
  _inherits(FormErrorScroller, _React$Component);

  var _super = _createSuper(FormErrorScroller);

  function FormErrorScroller() {
    var _this;

    _classCallCheck(this, FormErrorScroller);

    _this = _super.apply(this, arguments);
    _this.ref = React.createRef();
    return _this;
  }

  _createClass(FormErrorScroller, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isSubmitting && !this.props.isSubmitting && !this.props.isValid) {
        var form = this.ref.current ? this.ref.current.parentElement : null;

        if (!form) {
          return;
        }

        var firstInvalid = form.querySelector('[data-invalid]');

        if (firstInvalid && !isElementInViewport(firstInvalid)) {
          firstInvalid.scrollIntoView();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        ref: this.ref
      });
    }
  }]);

  return FormErrorScroller;
}(React.Component);